import { Button, Space } from "antd";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FormattedMessage, injectIntl, useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import Page from "../../Common/Page";
import PermissionCheck from "../../Common/PermissionCheck";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import { useHttp } from "../../hooks/useHttp";
import { useGetTeam } from "../Roster/hooks/useGetTeam";
import AddPersonToStaffModal from "./AddPersonToStaffModal";
import StaffMembers from "./Members/StaffMembers";
const PermissionName = PermissionNames.ROLES;

const ButtonToolbar = styled.div`
  display: flex;
  justify-content: end;
`;

function Staff() {
  const { formatMessage } = useIntl();
  const pageRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const { sport, organizationId, entityId, seasonId } = useParams();
  const [data, setData] = useState([]);
  const staffQuery = new URLSearchParams({
    entityId,
    seasonId,
    status: "ACTIVE",
    hideNull: true,
    include: ["persons", "entities"],
    limit: 1000,
  });

  const rosterURL = `/v1/${sport}/o/${organizationId}/roles?${staffQuery}`;
  const [roles, setRoles] = useState();
  const { request, loading } = useHttp();
  const loadRoles = useCallback(() => {
    request({
      url: rosterURL,
    })
      .then((data) => {
        setRoles(data);
      })
      .catch((e) => {
        console.error("error loading roles", e);
      });
  }, [request]);

  useEffect(() => {
    loadRoles();
  }, []);

  const refetch = useCallback(() => {
    loadRoles();
  }, []);

  useEffect(() => {
    if (roles) {
      setData({
        ...roles,
        data: roles?.data?.filter((person) => person?.role !== "CAPTAIN"),
      });
    }
  }, [roles]);

  const getTeamName = useCallback(() => {
    return roles?.includes?.resources?.entities?.[`${organizationId}:${entityId}`]?.nameFullLocal || ''
  }, [organizationId, entityId, roles?.includes?.resources.entities]);

  const { team: teamData } = useGetTeam({ dependencies: [entityId] });

  const teamName = teamData.nameFullLocal || "";

  const title = useMemo(() => `${teamName} ${formatMessage({ id: "staff" })}`, [formatMessage]);

  return (
    <Page title={title} tabTitle={title}>
      <Space direction="vertical" size="small" style={{ width: "100%" }}>
        <ButtonToolbar>
          <PermissionCheck permissionKeys={[PermissionNames.PERSON]}>
            <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.CREATE]}>
              <Button icon={<i className="fas fa-plus" />} type="primary" onClick={() => setIsOpen(true)}>
                <FormattedMessage id="staff.add" defaultMessage="Add New Staff Member" />
              </Button>
            </PermissionCheck>
          </PermissionCheck>
        </ButtonToolbar>
        <StaffMembers pageRef={pageRef} refetch={refetch} roles={data} loading={!roles || loading} />
      </Space>
      <PermissionCheck permissionKeys={[PermissionNames.PERSON]}>
        <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.CREATE]}>
          <AddPersonToStaffModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            pageRef={pageRef}
            personsAPI={null}
            reloadData={refetch}
          />
        </PermissionCheck>
      </PermissionCheck>
    </Page>
  );
}

export default Staff;
